export const ORIGINATOR_COOKIE = 'originator';
